import React, { Component, type JSX } from 'react';
import { Field, FormikProps } from 'formik';
import { CheckoutStateResponse, FormValues } from '../Checkout/Checkout.interface';

type Donation = CheckoutStateResponse['donation'];

export interface DonationProps extends Donation{
  form: FormikProps<FormValues>;
}

/**
 * This component renders the donation field in the checkout form.
 * The user can click either the 5 or 10 Euro donation option to fill
 * the input. Or manually provide a donation amount. Donations are optional.
 *
 * When there is only one donation available. The donation target id will
 * be stored in a hidden field. In case of multiple targets the user can
 * select a target from a select-box.
 *
 * The donation description and tooltip can be set by Marketing in the
 * wordpress admin.
 *
 * @example
 * <Donation {...donation} form={form}/>
 */
export class DonationComponent extends Component<DonationProps> {

  /**
   * In case there is only one donation target available
   * prefill it in the hidden input.
   */
  public async componentDidMount(): Promise<void> {
    const { items, form }: DonationProps = this.props;

    if (items.length === 1) {
      await form.setFieldValue('donation.target', items[0].id_item);
    }
  }

  /**
   * Either render the hidden input or display a select-box in case
   * there are multiple donations available.
   */
  public render(): JSX.Element {
    const { tooltip, description, items, form }: DonationProps = this.props;

    const options = items.map(item => (
      <option key={item.id_item} value={ item.id_item }>{ item.title }</option>
    ));

    return (
      <div className="checkout-donation checkout-list checkout-list--contrast">
        <h5 className="checkout-list__title">
            Doe mee
          { tooltip
            && <i className="checkout-list__info-icon fa fa-info-circle">
              <span className="checkout-list__tooltip js-tooltip"
                dangerouslySetInnerHTML={{ __html: tooltip }}>
              </span>
            </i>}
        </h5>
        <div className="checkout-list__description"
          dangerouslySetInnerHTML={{ __html: description }}>
        </div>

        { items.length > 1
          && <select name="donation.target" className="checkout-list__select bem-input-field">
            <option value="">Selecteer bestemming donatie</option>
            { options }
          </select>}
        { items.length === 1
            && <input name="donation.target" type="hidden"/>
        }
        <p className="checkout-list__description">
          <small>Selecteer een bedrag of doneer naar keuze</small>
        </p>

        <div className="checkout-donation__form">
          <div className="checkout-donation__amount-buttons">
              <div className="btn btn-primary checkout-donation__amount-btn" onClick={async () => {
                  await form.setFieldValue('donation.amount', 5);
              }}> &euro; 5
              </div>
              <div className="btn btn-primary checkout-donation__amount-btn" onClick={async () => {
                  await form.setFieldValue('donation.amount', 10);
              }}> &euro; 10
              </div>
          </div>

          <div className="checkout-donation__amount-field">
            <label className="checkout-donation__amount-input-prepend"
              htmlFor="donation_amount">&euro;</label>
            <Field type="number"
              name="donation.amount"
              min="0"
              step="0,01"
              className="checkout-donation__amount-input"
              placeholder="0.00"/>
          </div>
        </div>
      </div>
    );
  }

}
